









































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Overlay, Button } from "vant";
import { showQuickVerification } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";
const browser = getBrowser();

@Component({
  components: {
    [Overlay.name]: Overlay,
    [Button.name]: Button
  }
})
export default class VerifyPasswordDialog extends Vue {
  @Prop({
    type: Boolean,
    default() {
      return false;
    }
  })
  private value;
  
  @Prop({
    type: [String,Number],
    default() {
      return false;
    }
  })
  private accountType;
  
  

  oValue = false;
  password = "";
  isHL = false;

  get isSubmitDisabled() {
    return !this.password;
  }

  @Watch("value", { immediate: true })
  watchValue(val) {
    this.oValue = val;
    if (val && browser.isApp) {
      showQuickVerification({ type: "2" }, () => {
        this.$emit("verifySuccess");
      });
    }
  }

  mounted(){
    this.init();
  }

  init(){
    const userInfo =  (this as any).$localstorage.get("userInfo") || {};
    this.isHL = userInfo.is_model_hl ? true : false;
  }

  handleIconCloseClick() {
    
    this.password = "";
    this.oValue = false;
    this.$emit("input", this.oValue);
  }

  handleSubmitBtnClick() {
    (this as any).$apis
      .verifyTradePassword({
        password: this.password,
		account_type:this.accountType
      })
      .then(() => {
        this.$emit("verifySuccess");
      })
      .catch(e => {
        
      });
  }

  blur() {
    window.setTimeout(function() {
      window.scrollTo(0, document.body.clientHeight);
    }, 500);
  }
}
